import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";

interface ColumnsSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  visibleColumns: Record<string, boolean>;
  onVisibleColumnsChange: (columns: Record<string, boolean>) => void;
}

export function ColumnsSheet({
  open,
  onOpenChange,
  visibleColumns,
  onVisibleColumnsChange,
}: ColumnsSheetProps) {
  const toggleColumn = (column: string) => {
    onVisibleColumnsChange({
      ...visibleColumns,
      [column]: !visibleColumns[column],
    });
  };

  const columns = [
    { key: "totalOutstanding", label: "Total Outstanding" },
    { key: "current", label: "Current (0-30 days)" },
    { key: "days31_60", label: "31-60 Days" },
    { key: "days61_90", label: "61-90 Days" },
    { key: "days91_120", label: "91-120 Days" },
    { key: "over120", label: "Over 120 Days" },
    { key: "worstDaysOverdue", label: "Worst Days Overdue" },
    { key: "lastContactDate", label: "Last Contact" },
    { key: "riskLevel", label: "Risk Level" },
    { key: "aiPriorityScore", label: "AI Priority Score" },
    { key: "collectionStrategy", label: "Collection Strategy" },
    { key: "statusFlags", label: "Status Indicators" },
  ];

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Customize Columns</SheetTitle>
          <SheetDescription>
            Select which columns to display in the table. Customer Name and Actions are always visible.
          </SheetDescription>
        </SheetHeader>

        <ScrollArea className="h-[calc(100vh-180px)] pr-4 mt-6">
          <div className="space-y-4">
            {columns.map((column) => (
              <div key={column.key} className="flex items-center space-x-2">
                <Checkbox
                  id={column.key}
                  checked={visibleColumns[column.key]}
                  onCheckedChange={() => toggleColumn(column.key)}
                />
                <label
                  htmlFor={column.key}
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                >
                  {column.label}
                </label>
              </div>
            ))}
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
